import { type Account } from '@services/AccountService';

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

const isAge = (value: unknown) => value === null || typeof value === 'number';

export const isAccount = (value: unknown): value is Account =>
  isRecord(value) &&
  typeof value.dating === 'boolean' &&
  typeof value.matchmaker === 'boolean' &&
  typeof value.hidden === 'boolean' &&
  typeof value.allow_recommend === 'boolean' &&
  isRecord(value.search) &&
  isAge(value.search.age_from) &&
  isAge(value.search.age_to) &&
  isRecord(value.features) &&
  typeof value.features.matchmaker === 'boolean' &&
  typeof value.features.superlike === 'boolean';
